import axios from 'axios';

const url = 'https://class-rating.herokuapp.com/posts';

export const fetchPosts = () => axios.get(url);
export const createReview = (newPost) => axios.post(url, newPost);
// export const likePost = (id) => axios.patch(`${url}/${id}/likePost`);
// export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost);
export const deletePost = (id) => axios.delete(`${url}/${id}`);
